import { useShallow } from 'zustand/react/shallow';
import useGeneralSettingsStore from '../../../../../../../stores/GeneralSettings/useGeneralSettingsStore';
import useProductDetailsStore from '../../../../../../../stores/ProductDetails/productDetails.store';
import { CompactAvailability } from '../../../../../ProductTypes';
import { UseProductFiltersParams } from '../types/productFilters.types';
import useGetProductDetailsFilters from './useGetProductDetailsFilters';
import useResetUnavailableAvailability from './useResetUnavailableAvailability';

const useProductFilters = ({ allColorIds }: UseProductFiltersParams) => {
  const { productDetailsModalState, relatedProductsFilterState } = useProductDetailsStore(
    useShallow((state) => ({
      productDetailsModalState: state.productDetailsModalState,
      relatedProductsFilterState: state.relatedProductsFilterState,
    })),
  );
  const { filters, isLoading, isFetching } = useGetProductDetailsFilters({ allColorIds });

  const { enableRelatedProductsFilterInProductDetails, suggestedClassificationType } =
    useGeneralSettingsStore(
      useShallow((state) => ({
        enableRelatedProductsFilterInProductDetails:
          state.generalSettings.enableRelatedProductsFilterInProductDetails,
        suggestedClassificationType: state.generalSettings.suggestedClassificationType,
      })),
    );

  const availabilitiesFilter = !!productDetailsModalState.kitId
    ? [CompactAvailability.PRE_ORDER, CompactAvailability.READY_FOR_DELIVERY]
    : (filters?.availabilities ?? []);

  const hasNoAvailableGrid = !isLoading && !!filters && availabilitiesFilter.length === 0;

  useResetUnavailableAvailability({
    availabilities: availabilitiesFilter,
    isFiltersReady: !!filters && !isFetching,
  });

  const showAllColorsFilter = filters?.colors && filters?.colors?.length > 1;
  const showRelatedProductsFilter =
    enableRelatedProductsFilterInProductDetails &&
    !!suggestedClassificationType?.id &&
    !productDetailsModalState.kitId &&
    (!hasNoAvailableGrid || relatedProductsFilterState);

  return {
    filters: {
      ...filters,
      deliveryWindows: filters?.deliveryWindows,
      availabilities: availabilitiesFilter,
    },
    showAllColorsFilter,
    showRelatedProductsFilter,
    hasNoAvailableGrid,
    isLoading,
  };
};

export default useProductFilters;
